import { CarbonFootprint } from "@afidium/ts-facade";

export interface ICarbonFootPrint extends CarbonFootprint{
}

export interface ICarbonFootPrintDifference {
    value: number;
    isSuperior: boolean;
    isEqual: boolean;
}

export enum EWeightUnit {
    Kilogram = "Kilogram",
    Tons = "Tons",

}

export enum EUnitAbbr {
    Kilogram = "kg",
    Tons = "t",
}
